import Subject from "../cse4sub/Subject";
import React from 'react'
import cse302m from '../assets/CSE302mid21.pdf'
import cse302e from '../assets/CSE302end21.pdf'

export default function Ds() {
  return (
    <div>
       <Subject title="Data Structure(CSE302)"mid="Q. Paper"
    book1=" Data Structures and algorithm analysis in C++ by Mark Allen Weiss " 
    book2="Data Structures and Algorithm Analysis in C by Mark Allen Weiss
    "
    book1Link="http://www.uoitc.edu.iq/images/documents/informatics-institute/Competitive_exam/DataStructures.pdf
    " 
    book2Link="https://www.pdfdrive.com/download.pdf?id=5011786&h=af18bbde64de8a14b0ce0f96b4986589&u=cache&ext=pdf
    "
     int21="#" mid21={cse302m} end21={cse302e}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}